var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3337 21.1441H11.5874L9.52796 13.0563C9.43022 12.6843 9.22267 12.3554 8.91737 12.2003C8.15547 11.8108 7.31591 11.5007 6.40002 11.3444V11.033H10.8241C11.4347 11.033 11.8927 11.5007 11.969 12.044L13.0375 17.878L15.7825 11.033H18.4525L14.3337 21.1441ZM19.979 21.1441H17.3853L19.521 11.033H22.1147L19.979 21.1441ZM25.4703 13.8341C25.5466 13.2895 26.0046 12.9781 26.5388 12.9781C27.3784 12.8999 28.2929 13.0563 29.0562 13.4445L29.5141 11.2676C28.7509 10.9562 27.9113 10.7998 27.1494 10.7998C24.6321 10.7998 22.8003 12.2003 22.8003 14.1441C22.8003 15.6228 24.0978 16.3993 25.0137 16.867C26.0046 17.3334 26.3862 17.6448 26.3099 18.1112C26.3099 18.8108 25.5466 19.1222 24.7847 19.1222C23.8688 19.1222 22.9529 18.889 22.1147 18.4994L21.6568 20.6777C22.5727 21.066 23.5635 21.2223 24.4794 21.2223C27.3021 21.2992 29.0562 19.9 29.0562 17.7998C29.0562 15.1551 25.4703 15.0001 25.4703 13.8341ZM38.1334 21.1441L36.074 11.033H33.8619C33.404 11.033 32.946 11.3444 32.7934 11.8108L28.9798 21.1441H31.6498L32.1828 19.6668H35.4634L35.7687 21.1441H38.1334ZM34.2435 13.7559L35.0054 17.5666H32.8697L34.2435 13.7559Z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visaCard.3fefd62d525340a23c77f98f9d46b79f.svg";
export { ForwardRef as ReactComponent };